export const PERSON_COLORS = ["blue", "indigo", "purple", "pink", "orange", "green", "teal", "blue-light"];

export function personColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return PERSON_COLORS[Math.abs(hash) % PERSON_COLORS.length];
}

export default function personColorProps(name) {
  if (!name) return {};
  return { className: "classes-avatar-color", "data-color": personColor(name) };
}
